import React, { useEffect, useState } from "react";
import "components/Layout/style.css";
import AppBar from "components/Layout/AppBar";
import Box from "@mui/material/Box";
import DropDownIcon from "assets/img/dropdowncircule.svg";
import Ferme1 from "pages/Cahier/CahierTabs/Ferme1";
import DatePickerYear from "pages/Shared/CustomMonthYear";
import Store, { useStore } from "_Store";
import { useTable } from 'react-table'
import {  getFilterCahierData, getStockPdf } from "services/cachier.service";
import { getSeed } from "services/stock.service";
import moment from "moment";
import ShowIcons from "assets/img/img4.svg";
import TopHeadBox from "./TopHeadBox";
import styled from 'styled-components'
import {config} from '../../helpers/functions'
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import DialogDetails from "./DialogDetails/DialogDetails";
import { Loading } from "components/Ui";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useExportData } from "react-table-plugins";
import * as XLSX from 'xlsx';
import JsPDF from "jspdf";
import Button from "@mui/material/Button";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { registerLocale } from  "react-datepicker";
import Multiselect from 'multiselect-react-dropdown';
import useSeedData from "hooks/useSeedData";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import fr from 'date-fns/locale/fr';
import InitialSoldes from "./components/InitialSoldes";
registerLocale('fr', fr)

function formatDate(date) {
  return moment(new Date(date)).format("DD-MM-yyyy");
}
function removeSecondElement(array) {
  return array.map((subArray) => {
    return subArray.filter((element, index) => index !== 2);
  });
}
function getExportFileBlob({ columns, data, fileType, fileName }) {
  /* data=removeSecondElement(data)
  console.log(data,'**********') */
  if (fileType === "csv") {
    // CSV example
    const headerNames = columns.map((col) => col.exportValue);
    const csvString = Papa.unparse({ fields: headerNames, data });
    return new Blob([csvString], { type: "text/csv" });
  } else if (fileType === "xlsx") {
    // XLSX example

    const header = columns.map((column) =>{ 
      if(column.exportValue!=="Pièce"){
        let value=column.exportValue;
        if(column.parent) value= value+` ${column.parent.Header}`;
        return value
      }
     });
    const compatibleData = data.map((row) => {
      const obj = {};
      header.forEach((col, index) => {
        obj[col] = row[index];
      });
      return obj;
    });

    let wb = XLSX.utils.book_new();
    let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
      header,
    });
    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
    XLSX.writeFile(wb, `${fileName}.xlsx`);

    // Returning false as downloading of file is already taken care of
    return false;
  }
  //PDF example
  if (fileType === "pdf") {
    const headerNames = columns.map((column) =>{ 
      if(column.exportValue!=="Pièce"){
        let value=column.exportValue;
        if(column.parent) value= value+` ${column.parent.Header}`;
        return value
      }
    });
    const doc = new JsPDF({format: 'a4', orientation: 'landscape', unit: 'cm'});
    // Define the coordinates where you want to place the image
      var x = 0;
      var y = 0;

      // Load the image
      var img = new Image();
      img.src = location.origin + "/images/logo.jpeg";
      img.onload = function() {
        // Get the original dimensions of the image
        var width = img.width;
        var height = img.height;
        // Calculate the height that corresponds to a width of 236 pixels
        var newHeight = (236 / width) * height;
        // Add the image to the PDF with the new width and height
        doc.addImage(img, 'JPEG', x, y, 236, newHeight);
};

    doc.autoTable({
      headStyles:{fillColor: [16, 135, 88],minCellHeight: 1},
      head: [headerNames],
      body: data,
      margin: { to: 20 },
      theme: "striped",
      showHead: "everyPage",
      styles: {
        overflow: "linebreak",
        minCellHeight: 2,
        cellWidth:"auto",
        halign: "left",
        valign: "center",
        fontSize: 8,
      },
      startY: 0.5,
      didParseCell: function (data) {
        if (data.row.index === 0 && data.column.index === 0) {
          data.cell.text = 'Rapport de Stock';
        }
      }
    });
    doc.save(`${fileName}.pdf`);

    return false;
  }

  // Other formats goes here
  return false;
}

function makeData(cahierDetails) {
  let newData=[]
  if(cahierDetails && cahierDetails.length > 0){
    for(const details of cahierDetails){
      
      let entrees={b_entries:"N/A",b_exits:"N/A",b_solde:"N/A"};
      let sorties={c_entries:"N/A",c_exits:"N/A",c_solde:"N/A"};
      if(details.cashTransaction==="ENTRIES"){
        if(details.typeData.paymentMadeIn==="banque"){
          entrees.b_entries=(details.typeData.cost)+" CFA"
          entrees.b_solde=(details.solde)+" CFA"
        }else{
          sorties.c_entries= (details.typeData.cost)+" CFA"
          sorties.c_solde=(details.solde)+" CFA"
        }
      }
      if(details.cashTransaction==="EXITS"){
        if(details.typeData.paymentMadeIn==="banque"){
          entrees.b_exits=(details.typeData.cost)+" CFA"
          entrees.b_solde=(details.solde)+" CFA"
        }else{
          sorties.c_exits=(details.typeData.cost)+" CFA"
          sorties.c_solde=(details.solde)+" CFA"
        }
      }
      newData.push({
        date:{date : formatDate(details.date),justification:details.justification,},
        seed: (details.typeData.type && details.typeData.type==="autres entrees") ? '-' : details.seed,
        wording:details.wording,
        type:(details.typeData.type).toUpperCase(),
        jutification:details.file,
        pu:details.typeData.cost+" CFA",
        transaction:details.cashTransaction,
        ...entrees,
        ...sorties
      })
    }
  }
  return newData;
}

const CahierSheet = () => {
 const {
    state: {
      auth: { user },
      activeFarm,
      activeCampaign,
      farmList,
      entriesAndExitsOptionsList
    }, 
    setUtils
  } = useStore();
  const [cahierDetails, setCahierDetails] = useState(undefined);
  const [isLoading, setIsLading] = useState(false);
  const [open, setJustification] = React.useState(false);
  const [justification, setJustificationData] = React.useState(false);
  const newDate = new Date();
  const [date, setDate] = useState(
    moment(new Date(newDate.getFullYear(), newDate.getMonth(), 1)).format("L")
  );
  const { data: seedList } = useSeedData();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [availableSeeds, setAvailableSeed] = React.useState([]);
  const [selectedSeed, setSelectedSeeds] = React.useState("");
  const [filter, setFilter] = React.useState(false);
  const [soldeInititationVisible, setSoldeInititationVisible] = React.useState(false);
  const [disabledGenratorButton, setDisabledGenratorButton] = React.useState(false);

  function Table({ columns, data,reference,activeFarmData, activeCampaignData }) {
    // Use the state and functions returned from useTable to build your UI
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      exportData,
    } = useTable({
      columns,
      data,
      getExportFileBlob
    },useExportData)
  
    // Render the UI for your table
    return (
      <div>
      <Button style={{ marginBottom:"10px", marginTop:"10px",marginRight:"10px" }}
          size="small"
          variant="outlined"
          disabled={disabledGenratorButton}
          loading={disabledGenratorButton}
          startIcon={<PrintOutlinedIcon />}
          onClick={filterAndGetGeneratedPdf}>Rapport de stock PDF</Button>
     <Button style={{ marginBottom:"10px", marginTop:"10px", }}
          size="small"
          variant="outlined"
          startIcon={<NoteAddIcon />}
          onClick={
            ()=>exportData("xlsx", false, `${activeFarmData?.farmName}_${activeCampaignData.season==='GREAT' ? 'grande_saison' : 'petite_saison' }_${new Date().getFullYear()}`)
             }>Rapport de stock EXCEL</Button>
     
      <table {...getTableProps()} className="table_ table_cachier">
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}className="tr_head">
              {headerGroup.headers.map((column) => {
               return  <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()} className="tr_" style={{ background: row.original.transaction==="ENTRIES" ? "antiquewhite": "#e9b4b4" }}>
                {row.cells.map(cell => {
                    if(cell.column.Header==="Pièce"){
                      return <td style={{ background: row.original.transaction==="ENTRIES" ? "antiquewhite": "#e9b4b4" }} className="td_" {...cell.getCellProps()} target="_blank"> {cell.value ? <a href={config.local.imageBaseUrl+`cachier/${cell.value}`}>voir</a> : ""} </td>
  
                    }else
                    if(cell.column.Header==="Date"){
                      return <td style={{ background: row.original.transaction==="ENTRIES" ? "antiquewhite": "#e9b4b4" }} className="td_" {...cell.getCellProps()}>
                       <a target={"_blank"} onClick={()=>{setJustificationData(cell.value.justification);setJustification(true)}} style={{ color:"black",cursor:"pointer" }}><AddCircleOutlinedIcon/></a> &nbsp; 
                       {cell.value.date}
                        </td>
                    }else{
                      return <td style={{ background: row.original.transaction==="ENTRIES" ? "antiquewhite": "#e9b4b4" }} className="td_" {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    }
                  
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      </div>
    )
  }  
  const columns = React.useMemo(
    () => [
      {
        Header: 'Date',
        accessor: 'date',
      },
      {
        Header: 'Type',
        accessor: 'type',
      },
      {
        Header: 'Culture',
        accessor: 'seed',
      },
      {
        Header: 'Pièce',
        accessor: 'jutification',
      },
      {
        Header: 'Libellé',
        accessor: 'wording',
      },
     {
        Header: "Cahier de caisse",
        columns: [
          {
            Header: 'Entrée',
            accessor: 'c_entries',
          },
          {
            Header: 'Sortie',
            accessor: 'c_exits',
          },
          {
            Header: 'Solde',
            accessor: 'c_solde',
          }
        ],
          
      },
      {
        Header: "Cahier de banque",
        columns: [
          {
            Header: 'Entrée',
            accessor: 'b_entries',
          },
          {
            Header: 'Sortie',
            accessor: 'b_exits',
          },
          {
            Header: 'Solde',
            accessor: 'b_solde',
          }
        ],
          
      },
    ],
    []
  )

  const Styles = styled.div`
  overflow-y:auto;
  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

  const [tabIndex, setTabIndex] = React.useState(activeFarm.id);
  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  const getCahierDetails = async () => {
    setIsLading(true)
    let filterRes = {};
    if(startDate===null && endDate===null){
      filterRes = await getFilterCahierData(activeCampaign.id);
    }else{
      filterRes = await getFilterCahierData(activeCampaign.id, startDate,endDate);
    }
    if (filterRes.data.data) {
      setCahierDetails(filterRes.data.data);
      setIsLading(false)
    }else{
      if(filterRes.data.data && filterRes.data.data.length <=0) setIsLading(false);
    }
  };

  const refrence = React.createRef();
  const tableRef = React.createRef();

  useEffect(() => {
    getSeedData();
    getCahierDetails();
  }, [])

  useEffect(() => {
    getCahierDetails();
  }, [endDate])

  useEffect(() => {
    getCahierDetails();
  }, [tabIndex, date]);

  const filterAccToDate = (date) => {
    setDate(date);
  };

  const getSolde = (type) => {
    if(cahierDetails){
    let cashIn = 0;
    let cashOut = 0;
    let i = 0;
    while (i < cahierDetails.length) {
      if(cahierDetails[i]['typeData']["paymentMadeIn"] === type){
        if (cahierDetails[i]['cashTransaction'] === "ENTRIES") {
          cashIn += parseInt(cahierDetails[i]['typeData']['cost'].replace(/,/g, ''), 10);
        } else {
          cashOut += parseInt(cahierDetails[i]['typeData']['cost'].replace(/,/g, ''), 10);
        }
      }
      i += 1;
    }
    return (cashIn - cashOut);
    }else{
      return 0;
    }
  };


  async function filterStockDataByAllFilter(selected){
    let cachiersFilters=[];
    if(startDate ===null || endDate ===null){
      let datas = await getFilterCahierData(activeCampaign.id);
      cachiersFilters=datas.data.data;
      if(selected && selected.length>0){
        let seids=getDataId(selected);
        cachiersFilters=cachiersFilters.filter((p)=>seids.indexOf(p.seed)>=0)
      }
      
   }else{
      let datas = await getFilterCahierData(activeCampaign.id,startDate,endDate);
      cachiersFilters=datas.data.data;
      if(selected && selected.length>0){
        let seids=getDataId(selected);
        cachiersFilters=cachiersFilters.filter((p)=>seids.indexOf(p.seed)>=0)
      }
  }
  setCahierDetails(cachiersFilters);
  setIsLading(false)
  }

  function getSeedData(){

    let products = activeCampaign.productsYouGrow,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let seed = product.seed;
         data=[...data,{id: seed.id,name: seed.seedName}];
       }
     }
     setAvailableSeed(data)
   }

  function getDataId(datas){
    let seds=[];
    if(datas && datas.length>0){
      seds= datas.map((s)=>(s.name))
    }
    return seds
  }

  const handleSeedChange = (e) =>{
    setSelectedSeeds(e)
    setTimeout(function(){
      setIsLading(true)
      filterStockDataByAllFilter(e)
    },1000)
  }

  useEffect(() => {
      if(!activeCampaign.initialSoldeHasBeenSet)setSoldeInititationVisible(true);
    }, [activeCampaign])

    const downloadFile = (link) => {
      const anchor = document.createElement('a');
      anchor.href = link;
      anchor.target = "_blank";
      anchor.download = true;
      anchor.click();
    };
    function filterAndGetGeneratedPdf(){
      setDisabledGenratorButton(true)
      if(startDate ===null || endDate ===null){
        getStockPdf(activeCampaign.id).then((data) => {
          downloadFile(data.data.dataFileReturn.file)
          setDisabledGenratorButton(false)
      });
     }else{
      getStockPdf(activeCampaign.id,startDate,endDate).then((data) => {
        downloadFile(data.data.dataFileReturn.file)
        setDisabledGenratorButton(false)
      });
    }
    }
  

  function TabPanel(props) {
    const { value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        <div>
        <Box
                  className="firstcreatCreer mb-3 mr-3" style={{ marginTop: "0px",background:"antiquewhite",display:"inline-flex" }}
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    placeItems: "left",
                    p: 2,

                    bgcolor: "background.paper",
                    borderRadius: 1,
                  }}
                >
                  <div>
                    <p style={{ margin: "0", color: "#979797" }}>
                      {" "}
                      Solde Initial de caisse
                    </p>
                    <p
                      style={{
                        display: "flex",
                        margin: "0",
                        color: "#373737",
                      }}
                    >
                      {activeCampaign.initialCaisseSolde} CFA
                      <img src={DropDownIcon} style={{ marginLeft: "5px" }} />
                    </p>
                  </div>
                <div style={{ marginLeft:"20px" }}>
                    <p style={{ margin: "0", color: "#979797" }}>
                      {" "}
                      Solde Initial de banque
                    </p>
                    <p
                      style={{
                        display: "flex",
                        margin: "0",
                        color: "#373737",
                      }}
                    >
                      {activeCampaign.initialBanqueSolde} CFA
                      <img src={DropDownIcon} style={{ marginLeft: "5px" }} />
                    </p>
                  </div>
                </Box>
                {value === index && (
                <Box
                  className="firstcreatCreer" style={{ marginTop: "0px",display:"inline-flex" }}
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    placeItems: "left",
                    p: 2,

                    bgcolor: "background.paper",
                    borderRadius: 1,
                  }}
                >
                  <div>
                    <p style={{ margin: "0", color: "#979797" }}>
                      {" "}
                      Solde actuel en caisse
                    </p>
                    <p
                      style={{
                        display: "flex",
                        margin: "0",
                        color: "#373737",
                      }}
                    >
                      {getSolde("liquide")} CFA{" "}
                      <img src={DropDownIcon} style={{ marginLeft: "5px" }} />
                    </p>
                  </div>
                <div style={{ marginLeft:"20px" }}>
                    <p style={{ margin: "0", color: "#979797" }}>
                      {" "}
                      Solde actuel en banque
                    </p>
                    <p
                      style={{
                        display: "flex",
                        margin: "0",
                        color: "#373737",
                      }}
                    >
                      {getSolde('banque')} CFA{" "}
                      <img src={DropDownIcon} style={{ marginLeft: "5px" }} />
                    </p>
                  </div>
                </Box>
                )}
        </div>
        {value === index && (
              <div>
               
               {/*  <CahierTable cahierDetails={cahierDetails} /> */}
                <Styles>
                  <Table activeFarmData={activeFarm} activeCampaignData={activeCampaign} reference={tableRef} columns={columns} data={makeData(cahierDetails)} />
                </Styles>
              </div>
         )}
      <DialogDetails
        open={open}
        onClose={() => setJustification(false)}
        justification={justification}
      />
      </div>
    );
  }
  return (
    <>
      <div className="w-full sm:max-w-screen-2xl sm:px-6 mx-auto flex flex-col">
        <div className="pt-4">
          <AppBar />
        </div>
        <div>
          <TopHeadBox/>
        </div>
        {isLoading ? <Loading/> :<div>
        <Box className="feremtabn mt-5">
        <Box className="datepicbyyear mutliDateInput cachier_datepicker ml-0" style={{ display:"inline-block" }}>
            <Button style={{ marginBottom:"20px",marginRight:"10px" }}
                size="small"
                variant="outlined"
                color="info"
                startIcon={<FilterAltIcon />}
                onClick={()=>setFilter((!filter ? true : false))}> {filter ? "Fermer" : "Filtrer"}
            </Button>
            </Box>
              <div className="creatbtn-redirect">
                {" "}
                {cahierDetails?.length > 0 ? <Ferme1 /> : ""}
              </div>
            </Box>

            {filter ? 
                    <Box sx={{ mt: 4 }} style={{ background:"#fff" }} className="p-4">
                        <Box className="datepicbyyear mutliDateInput cachier_datepicker ml-0" style={{ display:"inline-block" }}>
                          <DatePicker
                            style={{ width:"300px" }}
                              locale="fr"
                              selectsRange={true}
                              startDate={startDate}
                              endDate={endDate}
                              onChange={(update) => {
                                setDateRange(update);
                              }}
                              placeholderText={"Trier par interval de Date"}
                              isClearable={true}
                            />
                            {/*   <MUIDatePickerInput onChange={getDate} /> */}
                          </Box>
                    <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block" }}>
                                      <Multiselect
                                        options={availableSeeds} // Options to display in the dropdown
                                        selectedValues={selectedSeed} // Preselected value to persist in dropdown
                                        onSelect={handleSeedChange} // Function will trigger on select event
                                        onRemove={handleSeedChange} // Function will trigger on remove event
                                        displayValue="name" // Property name to display in the dropdown options
                                        emptyRecordMsg="Aucune option trouvée"
                                        placeholder="Choisir une culture"
                                        style={{
                                          option: {  color: "black" },
                                          chips: { background: "#108758" },
                                          selected: { background: "#108758" },
                                        }}
                                        />
                    </div>
                    </Box>: ""}
                      

          <Box
            sx={{
              mt: 4,
            }}
          >
            {cahierDetails && cahierDetails.length <= 0 ? (
                  <div
                  style={{
                    marginTop: "80px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  <div className="">
                    <div>
                      <img src={ShowIcons} style={{ margin: "10px auto" }} />
                    </div>
                    <p>Vous n’avez pas créé de fiche de caisse</p>
                    <p>Cliquez sur le bouton créer une fiche de caisse</p>
                    <Ferme1 />
                  </div>
                  </div>
            ) :
              <div>
                      <TabPanel value={tabIndex} index={activeFarm.id} />
              </div>
            }
          </Box>
        </div>
        }
         <InitialSoldes
              visible={soldeInititationVisible}
              onCancel={() => {
                setSoldeInititationVisible(false);
              }}
              onSuccess={() => {
                setSoldeInititationVisible(false);
        }}
      />
      </div>
    </>
  );
};
export default CahierSheet;
